import { useState, useEffect } from 'react';
import api from '@/lib/api';

const CACHE_KEY = 'cavernicol_tenant_phone_code';
const FALLBACK = '+52';

export default function useTenantPhoneCode() {
  const [phoneCode, setPhoneCode] = useState(() => {
    try { return sessionStorage.getItem(CACHE_KEY) || FALLBACK; } catch { return FALLBACK; }
  });

  useEffect(() => {
    api.get('/tenant/profile').then(r => {
      const code = r.data?.phone_code || FALLBACK;
      setPhoneCode(code);
      try { sessionStorage.setItem(CACHE_KEY, code); } catch {}
    }).catch(() => {});
  }, []);

  return phoneCode;
}
